export class UseRouter {
  static PAGE_NAME: string = '/pages/'
  static PAGE_SUB_NAME: string = '/pages-sub/'
  static ORDER_SUB_NAME: string = '/order-sub/'

  static PAGE_HOME: string = this.PAGE_NAME + 'index/index' // 首页
  static PAGE_PRICING: string = this.PAGE_NAME + 'pricing/index' // 定价页面
  static PAGE_MY: string = this.PAGE_NAME + 'my/index' // 我的页面

  static PAGE_LOGIN_URL: string = this.PAGE_SUB_NAME + 'login/index' // 登录页
  static PAGE_REGISTER_URL: string = this.PAGE_SUB_NAME + 'register/index' // 注册页
  static PAGE_SETTING_URL: string = this.PAGE_SUB_NAME + 'setting/index' // 设置页
  static PAGE_SERVICE_URL: string = this.PAGE_SUB_NAME + 'service/index' // 客服中心
  static PAGE_ABOUT_URL: string = this.PAGE_SUB_NAME + 'about/index' // 关于我们
  static PAGE_COMMON_PROBLEM_URL: string = this.PAGE_SUB_NAME + 'commonProblem/index' // 常见问题
  static PAGE_COMMON_PICTURE_PRESENTATION_URL: string =
    this.PAGE_SUB_NAME + 'commonPicturePresentation/index' // 公共展示图片页面

  static PAGE_ADDRESS_MANAGE_URL: string = this.PAGE_SUB_NAME + 'addressManage/index' // 地址管理
  static PAGE_ADDRESS_OPERATOR_URL: string = this.PAGE_SUB_NAME + 'addressOperator/index' // 地址操作页
  static PAGE_BANK_MANAGE_URL: string = this.PAGE_SUB_NAME + 'bankManage/index' // 银行卡管理
  static PAGE_BANK_OPERATOR_URL: string = this.PAGE_SUB_NAME + 'bankOperator/index' // 银行卡操作页

  static PAGE_REAL_NAME_URL: string = this.PAGE_SUB_NAME + 'realName/index' // 认证页
  static PAGE_SIGN_AGREEMENT_URL: string = this.PAGE_SUB_NAME + 'signAgreement/index' // 协议阅读页
  static PAGE_SIGNATURE_URL: string = this.PAGE_SUB_NAME + 'signature/index' // 协议签名页
  static PAGE_USER_AGREEMENT_URL: string = this.PAGE_SUB_NAME + 'userAgreement/index' // 用户协议页
  static PAGE_CONTRACT_DOCUMENT_URL: string = this.PAGE_SUB_NAME + 'contractDocument/index' // 合同单据页
  static PAGE_CONTRACT_DETAILS_URL: string = this.PAGE_SUB_NAME + 'contractDetails/index' // 合同单据签收页
  static PAGE_SIGN_FACE_URL: string = this.PAGE_SUB_NAME + 'faceSign/index' // 小程序人脸认证
  static PAGE_FACE_RESULT_URL: string = this.PAGE_SUB_NAME + 'faceResult/index' // h5 /小程序 人脸认证结果页
  static PAGE_SUCCESS_URL: string = this.PAGE_SUB_NAME + 'success/index' // 成功反馈页
  static AGREEMENT_URL: string = this.PAGE_SUB_NAME + 'agreement/index' // 协议显示页
  static ORDER_SELL_GOLD_URL: string = this.ORDER_SUB_NAME + 'sellGold/index' // 卖料
  static ORDER_DEPOSIT_URL: string = this.ORDER_SUB_NAME + 'deposit/index' // 押金
  static ORDER_PAY_DEPOSIT_URL: string = this.ORDER_SUB_NAME + 'payDeposit/index' // 交押金
  static ORDER_SELL_ORDER_URL: string = this.ORDER_SUB_NAME + 'sellOrder/index' // 卖料订单
  static INCOMING_ORDER_URL: string = this.ORDER_SUB_NAME + 'IncomingOrder/index' // 来料订单
  static INCOMING_DETAILS_URL: string = this.ORDER_SUB_NAME + 'IncomingDetails/index' //  来料详情
  static ORDER_EXPRESS_INSURANCE_URL: string = this.ORDER_SUB_NAME + 'expressInsurance/index' // 顺丰发货 - 物流保险
  static ORDER_WARRANTY_URL: string = this.ORDER_SUB_NAME + 'warrantyDetails/index' // 保单详情
  static ORDER_CLAIM_STATEMENT_URL: string = this.ORDER_SUB_NAME + 'claimStatement/index' // 理赔说明
  static ORDER_PRICING_ORDER_URL: string = this.ORDER_SUB_NAME + 'pricingOrder/index' // 定价详情
  static ORDER_SETTLE_ORDER_URL: string = this.ORDER_SUB_NAME + 'settleOrderDetails/index' // 结算详情
  static ORDER_PENDING_ORDER_URL: string = this.ORDER_SUB_NAME + 'pending/index' // 待处理订单
  static ORDER_PENDING_INCOMING_URL: string = this.ORDER_SUB_NAME + 'pendingIncoming/index' // 检测报告
  static ORDER_SETTLE_TABLE_DETAILS_URL: string =
    this.ORDER_SUB_NAME + 'settleOrderTableDetails/index' // 结算详情表格数据

  static ORDER_REMIND_URL: string = this.ORDER_SUB_NAME + 'remind/index' // 价格提醒
  static ORDER_EXPRESS_DETAILS_URL: string = this.ORDER_SUB_NAME + 'expressDetails/index' //  快递详情
}
